// src/components/FinderSteps.jsx
import React from 'react';

export default function FinderSteps({ language = 'en', onBack }) {
  const content = {
    en: [
      { title: "Scan the QR code", desc: "Use your phone camera to open the return instructions.", imgDesc: "Phone scanning a QR code on an item" },
      { title: "Follow the owner's instructions", desc: "Complete the return form or contact them directly.", imgDesc: "Following return instructions on a phone screen" },
      { title: "Return the item", desc: "Drop it off or arrange a meeting point with the owner.", imgDesc: "Returning the backpack to a location" },
    ],
    es: [
      { title: "Escanea el código QR", desc: "Usa tu cámara para abrir las instrucciones de devolución.", imgDesc: "Teléfono escaneando un código QR en un objeto" },
      { title: "Sigue las instrucciones del propietario", desc: "Llena el formulario o contáctalo directamente.", imgDesc: "Pantalla del móvil mostrando instrucciones de devolución" },
      { title: "Devuelve el artículo", desc: "Entrégalo o coordina un punto de encuentro con el dueño.", imgDesc: "Entrega de un morral en una ubicación específica" },
    ],
    pt: [
      { title: "Escaneie o código QR", desc: "Use a câmera do celular para acessar as instruções.", imgDesc: "Celular escaneando um código QR em um item" },
      { title: "Siga as instruções do dono", desc: "Preencha o formulário ou entre em contato diretamente.", imgDesc: "Tela do celular exibindo instruções de devolução" },
      { title: "Devolva o item", desc: "Entregue o objeto ou combine um local com o proprietário.", imgDesc: "Devolução da mochila em local específico" },
    ],
  };

  const stepsTitle = {
    en: "Step ",
    es: "Paso ",
    pt: "Passo ",
  };

  const stepImg = [
    "/assets/images/howitworks/finderstep1.webp",
    "/assets/images/howitworks/finderstep2.webp",
    "/assets/images/howitworks/finderstep3.webp",
  ];

  const steps = content[language];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-[1536px] mx-auto px-4">
        <div className="grid gap-10 md:grid-cols-1 lg:grid-cols-3 text-gray-800">
          {steps.map((step, index) => (
            <div key={index} className="p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition">
              <div className="text-xl font-bold text-[#48887B] mb-2">
                {`${stepsTitle[language]}${index + 1}`}
              </div>
              <img
                src={stepImg[index]}
                alt={step.imgDesc}
                className="w-20 h-20 mx-auto my-4 object-contain"
              />
              <h3 className="text-lg font-semibold text-center">{step.title}</h3>
              <p className="mt-2 text-gray-600 text-sm text-center">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <button
        onClick={onBack}
        className="mt-10 mx-auto block px-6 py-2 bg-[#48887B] text-white rounded-lg hover:bg-[#3b726a] transition"
      >
        {language === 'es'
          ? 'Volver'
          : language === 'pt'
          ? 'Voltar'
          : 'Back'}
      </button>
    </section>
  );
}
